<template>
  <article>
    <vs-row align="center" justify="center" v-if="logo">
      <img class="logo" :src="logo_url"/>
    </vs-row>
    <vs-row align="center" justify="center">
      <h1>{{contentCopies.welcome_header}}</h1>
      <h3>{{contentCopies.welcome_body}}</h3>
    </vs-row>
    <vs-row align="center" justify="center">
      <vs-input
        id="input-components-landing-winnercode"
        v-model="winnerCode"
        color="#83bc00"
        placeholder="ABCD1234"
        border
      />
    </vs-row>
    <vs-row v-if="automation_active !== 'yes'" align="center" justify="center">
      <vue-recaptcha
        :sitekey="sitekey"
        @verify="captchaSuccess"
        @expired="captchaExpired"
        ref="captcha"
      ></vue-recaptcha>
    </vs-row>
    <vs-row type="flex" align="center" justify="center" class="mt-2">
      <vs-button
        id="btn-components-landing-enter"
        square
        ref="submit"
        color="#83bc00"
        size="large"
        @click="validateToken"
        :disabled="!captchaVerified"
      >
        ENTER
      </vs-button>
    </vs-row>
  </article>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'Landing',
  props: {
    promoName: {
      type: String,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
    logo:{
      type:String,
      require:false
    },
    logo_url:{
      type:String,
      require:false
    },
    contentCopies: {
      type: Object,
      require: true,
    },
  },
  components: {
    VueRecaptcha,
  },
  methods: {
    captchaSuccess(response) {
      this.captchaVerified = true;
      this.captchaToken = response;
    },
    captchaExpired() {
      this.captchaVerified = false;
    },
    validateToken() {
      if (!this.winnerCode) {
        this.$emit('error', 'Sorry, it seems the winner code is empty.');
        this.$refs.captcha.reset();
        this.captchaVerified = false;
        return;
      }
      const loading = this.$vs.loading({color:'#83bc00'}); 
      const url = `redeem/winners/token?redeemToken=${this.winnerCode}&captcha_token=${this.captchaToken}`;
      
      this.$http
        .get(url)
        .then(result => {
          this.promo_name = result.data.promo_name;
          this.validationAddress = result.data.allowOneAddress;
          this.$emit('success', this.promo_name, this.winnerCode, this.validationAddress, result.data.allow_gift_site, result.data.reward_site_data, result.data.active_size_field, result.data.active_phone_field);
          loading.close();
        })
        .catch((error) => {
          loading.close();
          this.$emit('error', this.getErrorMessage(error), false, this.winnerCode);
        });
    },
  },
  computed: {
    sitekey() {
      return this.recaptcha_site_key;
    },
  },
  data() {
    return {
      captchaVerified: this.automation_active === 'yes',
      winnerCode: null,
      promo_name: null,
      captchaToken: null,
      validationAddress: false,
      logoValue: null,
    };
  },
  watch: {
    promoName: function() {
      this.promo_name = this.promoName;
    },
  },
  created() {
    this.winnerCode = this.code;
    this.promo_name = this.promoName;
  },
};
</script>

<style lang="scss" scoped>


h1 {
  color: #83bc00;
  font-size: 48px;
  font-weight: 700;
  margin: 1rem 0 0 0;
  text-transform: uppercase;
  width:100%;
}

h2 {
  color: #83bc00;
  font-size: 40px;
  font-weight: 700;
  margin: 0 0 1rem 0 ;
}


h3 {
  font-size: 32px;
  font-weight: 700;
  margin: 1rem 0;
}

 @media (max-width: 768px) {
    h1{
      font-size: 28px;
    }
    h2{
      font-size: 20px;
    }
    h3{
      font-size: 12px;
    }
}

p {
  font-size: 1.2rem;
  font-weight: 400;
}
.logo{
  max-width: 200px;
}
.mt-2 {
  margin-top: 1rem;
}

::v-deep .vs-button__content {
  font-weight: 600;
}

::v-deep .vs-input-parent {
  .vs-input {
    font-size: 1.2rem;
    text-align: center;
    width: 100%;
    max-width: 30rem;
  }
  .vs-input-content{
    max-width: 30rem;
  }
  margin: 1rem 0;
  width: 80%;
  align-items: center;
}
</style>
